import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { rtkapi } from './rtkapi';
import { userSlice } from './userSlice';

const store = configureStore({
    reducer: {
        // Add the generated reducer as a specific top-level slice
        [rtkapi.reducerPath]: rtkapi.reducer,
        user: userSlice.reducer,
      },
      // Adding the api middleware enables caching, invalidation, polling,
      // and other useful features of `rtk-query`.
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(rtkapi.middleware),
});


setupListeners(store.dispatch)

export default store
